<style>
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/standing_book/page"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeiSN')">
            <el-input v-model="yt.conditions.sn"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button  @click="yt.get(1)" type="primary" plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button  @click="yt.clear({orderBy:'sort'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #suoshuzuzhi="{ row }">
        <span>{{ selectOrgName !== '' ? formatData(selectOrgName,row) : row.orgName }}</span>
      </template>
    </yi_curd_table>


  </div>
</template>

<script>
  export default {
    name: 'web_base_equipment_equipment_standing',
    data() {
      return {
        organizationList: [],
        columns: [{
          label: 'shebeimingcheng',
          prop: 'name',
          width: 130
        }, {
          label: 'shebeiSN',
          prop: 'sn',
          width: 130
        }, {
          type: 'slot',
          label: 'suoshuzuzhi',
          prop: 'orgName',
        }],
        selectIds: []
      };
    },
    computed: {
      selectOrgName() {
        if (this.Equipment.simpleOrgId) {
          this.selectIds = this.$refs['yt'].$parent.$parent['id_bind']
          const result = this.organizationList.filter(item => {
            return item.id === this.Equipment.simpleOrgId
          })
          return result.length > 0 ? result[0]['name'] : ''
        }
        return ''
      }
    },
    watch: {
    },
    inject: ['Equipment'],
    created() {
      setTimeout(() => {
		  this.yt.conditions = {
		  	orderBy: 'sort'
		  }
        this.yt.SELECT_URL = "/web/equipment/standing_book/getEquipmentByIds"
        this.yt.SELECT_RESULT_KEY = "data"
        this.yt.SELECT_ID = "id"
        this.yt.SELECT_TITLE = "name"
        this.yt.get(1);
        // this.getOrganizationList()
      }, 300)
    },
    methods: {
      // async getOrganizationList() {
      //   let response = await this.http.get('/web/setting/org/page', {
      //     params: {
      //       pageNum: 1,
      //       pageSize: 100
      //     }
      //   })
      //   this.organizationList = response.data.rows
      // },
      formatData(data, row) {
        if (this.selectIds.includes(row.id)) {
          return data
        } else {
          return row.orgName
        }
      }
    }
  };
</script>
